import { Time } from "@carbon/icons-react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import moment from "moment";
import { useTranslation } from "react-i18next";

import { TimeSlotFragment } from "../../../../models/autogenerated-deliveryService-gql/graphql";
import "./TimeSlotSelectionCard.scss";

require("moment/locale/de");

interface TimeSlotSelectionCardProps {
  start: string;
  end: string;
  timeSlotOption?: TimeSlotFragment;
  selectedTimeSlot?: TimeSlotFragment;
  onTimeSlotSelection(timeSlotOption?: TimeSlotFragment): void;
}

const TimeSlotSelectionCard = (props: TimeSlotSelectionCardProps) => {
  const { t } = useTranslation();
  const {
    start,
    end,
    selectedTimeSlot,
    onTimeSlotSelection,

    timeSlotOption,
  } = props;

  const isSelected =
    selectedTimeSlot !== undefined && timeSlotOption !== undefined
      ? selectedTimeSlot.end === timeSlotOption.end
      : false;

  const formattedTimeSlotString = end
    ? `${moment(new Date(start))
        .locale(t("locale"))
        .format(t("untilTime"))} - ${moment(new Date(end))
        .locale(t("locale"))
        .format(t("untilTimeFull"))}`
    : `${moment(new Date(start))
        .locale(t("locale"))
        .format(t("untilTimeFull"))}`;

  const formattedDateString = moment(new Date(start))
    .locale(t("locale"))
    .format(t("dateFormat"));

  return (
    <Card
      variant="outlined"
      className={`timeslotcard ${isSelected ? "selected " : ""}`}
      data-testid="timeslot-selection-card-select"
      onClick={() => onTimeSlotSelection(timeSlotOption)}
    >
      <CardContent
        data-testid="timeslot-selection-card"
        className="card-container"
      >
        <div className="timeslot-selection-card-text">
          <div className={"icon " + (isSelected ? "selectedFont" : "")}>
            <Time size={20} />
          </div>
          <div className="dateTime">
            <div className={"date " + (isSelected ? "selectedFont" : "")}>
              <Typography>{formattedDateString}</Typography>
            </div>
            <div className={"time " + (isSelected ? "selectedFont" : "")}>
              <Typography>{formattedTimeSlotString}</Typography>
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default TimeSlotSelectionCard;
